import { ERROR_MESSAGES } from '@/constants/ERRORS.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'
import axios from 'axios'

const api = axios.create()

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    switch (error?.response?.status) {
      case 401:
        window.location.replace('/')
        break
      case 403:
        GlobalPubSub.publish(GlobalPubSub.Signals.DISPLAY_SYSTEM_MESSAGE_MODAL, ERROR_MESSAGES.FORBIDDEN)
        break
      default:
        return Promise.reject(error)
    }
  },
)

export default api
